import { Box, Grid, Stack, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { GUIDANCE_LEVELS } from "../../../constants";

export default function GuidanceLevelsModal({ close }) {
  return (
    <Box
      sx={{
        width: '689px',
        borderRadius: '16px',
        backgroundColor: 'background.white',
        overflowY: 'none',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
        padding: '24px 16px'
      }}
    >
      <Stack
        direction={'column'}
        spacing={'40px'}
      >
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Typography variant="h2">
            Guidance levels
          </Typography>
          <CloseIcon
            sx={{
              width: '32px',
              height: '32px',
              color: 'primary.black',
              cursor: 'pointer',
              position: 'absolute',
              top: '24px',
              right: '16px'
            }}
            onClick={close}
          />
        </Box>
        <Typography variant="subText">
          Guidance levels indicate where you lie compared to the general population.
        </Typography>
        <Box>
          <Grid container spacing={'16px'}>
            {GUIDANCE_LEVELS.map((item => (
              <Grid item xs={12} md={4} key={item.label}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    borderRadius: '16px',
                    padding: '16px',
                    bgcolor: item.bgColor
                  }}
                >
                  <Typography variant="h4">{item.label}</Typography>
                  <Typography variant="subText" mt="24px" whiteSpace={'pre-wrap'}>
                    {item.description}
                  </Typography>
                </Box>
              </Grid>
            )))}
          </Grid>
        </Box>
      </Stack>
    </Box>
  )
}